<ng-container *ngIf="readonly; else toggleInput">
  <span class="text-underline cursor-pointer" (dblclick)="onToggleInput()">
    <ng-container *ngIf="!hasComparedValue; else compare">
      <ng-container *ngIf="!withDecimal; else decimal">
        {{ value | number: '1.0' : 'en-US' }}
      </ng-container>
      <ng-template #decimal>
        {{ value | decimalPlaces }}
      </ng-template>
    </ng-container>
    <ng-template #compare>
      {{ value | decimalPlaces }} / {{ comparedValue | decimalPlaces }}
    </ng-template>
  </span>
</ng-container>
<ng-template #toggleInput>
  <input
    [formControl]="control"
    type="number"
    inputmode="numeric"
    class="lum-input w-30 text-end"
    matInput
    (keyup.enter)="onToggleInput()"
    (input)="onInput($event)"
    lumDecimalLimit
  />
</ng-template>
